<template>
  <div class="w-full bg-white font-sans text-gray-800">
    <Headers />
    <section class="w-full max-w-[1400px] mx-auto">
      <div class="carousel-container">
        <HeroCarousel />
      </div>
    </section>
    <div>
      <div class="bg-white py-8 px-4 sm:px-6 lg:px-8">
        <div class="max-w-7xl mx-auto">
          <!-- 标题 -->
          <!-- 产品网格 -->
          <div class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <!-- 产品卡片 -->
            <div
              v-for="product in indexProducts"
              :key="product.id"
              class="group cursor-pointer"
              @click="jump(`/product-detail?id=${product.id}`)"
            >
              <!-- 产品图片容器 -->
              <div class="relative w-full h-48 mb-4 overflow-hidden rounded-lg">
                <img
                  :src="product.image"
                  :alt="product.name"
                  class="product-image w-full h-48 object-contain"
                />
              </div>

              <!-- 产品信息 -->
              <div class="text-center">
                <h3 class="text-sm font-medium text-gray-700 uppercase mb-2">
                  {{ product.name }}
                </h3>
                <p class="text-sm text-gray-900">
                  <span v-if="product.pricePrefix"
                    >{{ product.pricePrefix }}
                  </span>
                  <!-- <span class="font-medium">${{ product.price }}</span> -->
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="w-full py-10 bg-white text-center px-4" v-if="false">
      <div class="max-w-xl mx-auto">
        <div class="mb-4 flex justify-center text-gray-400">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-8 w-8"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg>
        </div>

        <h2 class="text-lg font-bold tracking-widest uppercase mb-2">
          Keep Posted to Latest Events
        </h2>
        <p class="text-xs text-gray-400 mb-8">
          Subscribe to receive 10% off your first order & exclusive offers.
        </p>

        <div class="flex flex-col sm:flex-row gap-4 mb-6">
          <input
            type="email"
            placeholder="Enter your email address"
            class="flex-1 bg-gray-100 border-none rounded px-4 py-3 text-sm focus:ring-1 focus:ring-black outline-none"
          />
        </div>

        <div
          class="grid grid-cols-2 gap-y-2 gap-x-4 text-left text-[10px] text-gray-500 mb-8 max-w-sm mx-auto"
        >
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" class="accent-black" /> New Arrivals
          </label>
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" class="accent-black" /> Special Offers
          </label>
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" class="accent-black" /> Product Updates
          </label>
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" class="accent-black" /> Events
          </label>
        </div>

        <button
          class="bg-black text-white px-10 py-3 rounded-full text-xs font-bold hover:bg-gray-800 transition"
        >
          SUBSCRIBE
        </button>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Headers from "@/components/Headers.vue";
import Footer from "@/components/Footer.vue";
import HeroCarousel from "@/components/HeroCarousel.vue";
import { indexProduct } from "../data/data";
export default {
  name: "HomeContent",
  components: {
    Headers,
    HeroCarousel,
    Footer,
  },
  data() {
    return {
      indexProducts: indexProduct,
    };
  },
  computed: {},
  methods: {
    jump(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
.carousel-container {
  width: 100%;
  height: 250px;
}

@media (min-width: 640px) {
  .carousel-container {
    height: 350px;
  }
}

@media (min-width: 768px) {
  .carousel-container {
    height: 400px;
  }
}

@media (min-width: 1024px) {
  .carousel-container {
    height: 450px;
  }
}

@media (min-width: 1280px) {
  .carousel-container {
    height: 500px;
  }
}

.product-image {
  transition: transform 0.3s ease-in-out;
}

.product-image:hover {
  transform: scale(1.1);
}
</style>
